module.exports = __webpack_public_path__ + "static/media/charlesDuCouedicDeKererant.8609b21e.png";